// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import { getPeriod } from '../services/lessonSet';
import { classDetail, setAssemble } from '../services/courseTable';
import { setListData } from '../utils';

const initState = {
  // 分页信息
  pageInfo: {
    page: 1,
    pageSize: 10,
    totalElements: 0,
    totalPages: 1,
  },
  // 加载信息
  spinProps: {
    spinning: false,
    tip: '加载中...',
  },
  courseData: [],
  allData: [],
};

export default {
  namespace: 'courseTable',
  state: initState,
  effects: {
    *fetchGetPeriod({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        const response = yield call(getPeriod, params);

        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
            courseData: response,
          },
        });
        yield put({
          type: 'fetchCourseAll',
          params,
        });
        return Promise.resolve(response);
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchCourseAll({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        const response = yield call(classDetail, params);

        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
            pageInfo: {
              page: 1,
              pageSize: 10,
              totalElements: response.length,
              totalPages: 1,
            },
            allData: setListData(response),
          },
        });
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
      }
    },
    *fetchSetAssemble({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        yield call(setAssemble, params);

        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
        router.goBack();
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
